import { injectable, inject } from 'inversify';
import { XApiClient } from '@/app/tracking/xapi/tincan/client';
import { ok, err } from '@/app/tracking/tracking-api';
import { BookmarkDataStore, BookmarkErrorCode, Bookmark, defaultBookmark } from '../common';

function error(code: BookmarkErrorCode, details: unknown) {
  return err({ code, details });
}

const STATE_ID = 'bookmark';

@injectable()
export class XApiBookmarkStore implements BookmarkDataStore {

  constructor(
    @inject(XApiClient)
    private client: XApiClient) {
  }

  public async get() {
    const result = await this.client.loadState(STATE_ID);
    if (!result.success) {
      return error('query-error', result.error);
    }

    if (result.value === null) {
      return ok(defaultBookmark());
    }

    return ok(result.value as Bookmark);
  }

  public async update(bookmark: Bookmark) {

    const result = await this.client.saveState(STATE_ID, bookmark);
    if (!result.success) {
      return error('update-error', result.error);
    }

    return ok(true as true);
  }
}
